module.exports = __webpack_public_path__ + "static/media/trade-in.ad28f259.svg";